import { render, staticRenderFns } from "./GridView.vue?vue&type=template&id=06b5a5ba&"
import script from "./GridView.vue?vue&type=script&lang=js&"
export * from "./GridView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports